// extracted by mini-css-extract-plugin
export default {"wrapper":"E5bVVM","headerWrapper":"EzV1Ab","contentWrapper":"SVxIav","header":"eZmxkv","closeIcon":"a7b9wD","content":"mWYxib"};